import { useState } from 'react';
import WeddingReportFeed from './WeddingReportFeed';
import WeddingReportSheet from './WeddingReportSheet';

/** Self-contained wedding-rollup feed + slide-over, registered as an operation component. */
export default function WeddingReportOperation({ soulId }: { soulId: string }) {
  const [openReportId, setOpenReportId] = useState<string | null>(null);
  return (
    <>
      <WeddingReportFeed soulId={soulId} onOpenReport={setOpenReportId} />
      <WeddingReportSheet
        reportId={openReportId}
        open={!!openReportId}
        onOpenChange={(o) => !o && setOpenReportId(null)}
      />
    </>
  );
}
